import { createContext, useState, useCallback, useEffect, createElement, Fragment, useContext } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = (function () { });

var initialContext = {
    consent: null,
    openPanel: noop,
    closePanel: noop,
    updateConsent: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    acceptCategory: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    acceptAllCategories: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    acceptPreselectedCategories: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    declineAllCategories: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    declineCategory: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
    withdrawConsent: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, noop()];
    }); }); },
};
var context = createContext(initialContext);

var INIT_EVENT = "cf_init";
var CONSENT_EVENT = "cf_consent";
var getContextFromCfObject = function (CookieFirst) { return ({
    consent: CookieFirst.consent,
    openPanel: CookieFirst.openPanel,
    closePanel: CookieFirst.closePanel,
    updateConsent: CookieFirst.updateConsent,
    acceptCategory: CookieFirst.acceptCategory,
    acceptAllCategories: CookieFirst.acceptAllCategories,
    acceptPreselectedCategories: CookieFirst.acceptPreselectedCategories,
    declineAllCategories: CookieFirst.declineAllCategories,
    declineCategory: CookieFirst.declineCategory,
    withdrawConsent: CookieFirst.withdrawConsent,
}); };
var useContextManager = function () {
    var _a = useState(false), isLoaded = _a[0], setIsLoaded = _a[1];
    var _b = useState(initialContext), context = _b[0], setContext = _b[1];
    var handleInit = useCallback(function () {
        if (!window.CookieFirst) {
            return;
        }
        setContext(getContextFromCfObject(window.CookieFirst));
        setIsLoaded(true);
    }, []);
    var handleConsent = useCallback(function () {
        if (!window.CookieFirst) {
            return;
        }
        setContext(getContextFromCfObject(window.CookieFirst));
    }, []);
    useEffect(function () {
        window.addEventListener(INIT_EVENT, handleInit);
        window.addEventListener(CONSENT_EVENT, handleConsent);
        return function () {
            window.removeEventListener(INIT_EVENT, handleInit);
            window.removeEventListener(CONSENT_EVENT, handleConsent);
        };
    }, []);
    return [isLoaded, context];
};

/**
 * Loads CookieFirst banner script if apiKey setting is provided.
 * Executes script loading only once, on initial render
 * @param {UseLoadCFSCriptSettings} settings
 */
var useLoadCFScript = function (_a) {
    var apiKey = _a.apiKey, silent = _a.silent, stealth = _a.stealth, lang = _a.lang;
    useEffect(function () {
        if (!apiKey) {
            return;
        }
        var script = document.createElement("script");
        script.src = "https://consent.cookiefirst.com/banner.js";
        script.async = true;
        script.setAttribute("data-cookiefirst-key", apiKey);
        if (typeof silent !== "undefined") {
            script.setAttribute("data-silent-mode", silent ? "true" : "false");
        }
        if (typeof stealth !== "undefined") {
            script.setAttribute("data-stealth-mode", stealth ? "true" : "false");
        }
        if (typeof lang !== "undefined") {
            script.setAttribute("data-language", lang);
        }
        document.body.appendChild(script);
        return function () {
            document.body.removeChild(script);
        };
    }, []);
};

var ReactCookieFirst = function (_a) {
    var apiKey = _a.apiKey, silent = _a.silent, stealth = _a.stealth, lang = _a.lang, children = _a.children, _b = _a.renderBeforeReady, renderBeforeReady = _b === void 0 ? false : _b;
    useLoadCFScript({ apiKey: apiKey, silent: silent, stealth: stealth, lang: lang });
    var _c = useContextManager(), isLoaded = _c[0], context$1 = _c[1];
    if (!isLoaded && !renderBeforeReady) {
        return createElement(Fragment, null);
    }
    return (createElement(context.Provider, { value: context$1 }, children));
};
var useCookieFirst = function () { return useContext(context); };

export default ReactCookieFirst;
export { useCookieFirst };
//# sourceMappingURL=index.es.js.map
